export {
  CURRENCY_SYMBOL,
  SUPPORTED_CURRENCIES,
  type CurrencyCode,
} from "@/shared/currency/constants";

export interface CurrencyProps {
  code: string;
  symbol: string;
}

export interface CurrencyConversionRates {
  [key: string]: number;
}

export interface CurrencyContextProps {
  currency: CurrencyProps;
  setCurrency: (data: CurrencyProps) => void;
  currencyConversionRates: CurrencyConversionRates;
  setCurrencyConversionRates: (data: CurrencyConversionRates) => void;
  isLoading: boolean;
}
